interface ActionTypes {
  LOGOUT_START: string;
  LOGOUT_SUCCESS: string;
  LOGOUT_FAILURE: string;
}

export const LogoutLocalActionTypes: ActionTypes = {
  LOGOUT_START: '@@LOGOUT_START',
  LOGOUT_SUCCESS: '@@LOGOUT_SUCCESS',
  LOGOUT_FAILURE: '@@LOGOUT_FAILURE'
};

export interface LogoutLocalState {
  status?: 'loging-out' | 'loged-out' | 'failed-log-out';
}
